<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
// import { ModelListSelect } from "vue-search-select";
import Swal from "sweetalert2";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Stock Transfers",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      title: "Stock Transfers",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Stock Transfers Report",
          active: true,
        },
      ],
      filterdata:{
        dateto:moment(new Date()).format("YYYY-MM-DD"),
        datefrom:'',
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      totalRows: 1,
      filterTitle: "Stock Transfer Report",
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      filteredReport:[],
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product",
          sortablep: true,
          label: "PRODUCT",
        },
        {
          key: "source",
          sortable: true,
          label: "SOURCE",
        },
        {
          key: "source_type",
          sortable: true,
          label: "SOURCE TYPE",
        },
        {
          key: "destination",
          sortable: true,
          label: "DESTINATION",
        },
        {
          key: "qty_sent",
          sortable: true,
          label: "QUANTITY SENT",
        },
        {
          key: "qty_received",
          sortable: true,
          label: "QUANTITY RECEIVED",
        },
        {
          key: "unit",
          sortable: true,
          label: "UNITS",
        },
        {
          key: "transfer.sentOn",
          sortable: true,
          label: "SENT ON",
        },      
        {
          key: "receivedby",
          sortable: true,
          label: "RECEIVED BY",
        },
        {
          key: "status",
          sortable: true,
          label: "STATUS",
        }
      ],
      json_fields: {
        PRODUCT: "product",
        SOURCE: "source",
        SOURCE_TYPE: "source_type",
        DESTINATION: "destination",
        QUANTITY_SENT: "qt_rcv",
        QUANTITY_RECEIVED: "qty_received",
        UNITS: "unit",
        SENT_ON: "transfer.sentOn",
        RECEIVED_BY: "receivedby",
        RECEIVED_ON: "receivedOn",
        STATUS: "status",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("stocktransfer", ["SaveStatus","StockTransfersDetails"]),
    ...mapGetters("general", ["BusinessSettings"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.filteredReport ? this.filteredReport.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.filteredReport ? this.filteredReport.length : 1;
  },
  // updated() {
  //   this.FetchfilteredData();
  // },
  methods: {
    ...mapActions({
      FetchTransfers: "stocktransfer/fetchStockTransfersDetails",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    FetchfilteredData(){
      this.filteredReport = this.StockTransfersDetails;
    },

    filterReport() {
      let date2 = this.filterdata.dateto;
      let date1 = this.filterdata.datefrom;
      this.filteredReport = this.StockTransfersDetails.filter((element) => {
        if (
          this.filterdata.datefrom != "" &&
          this.filterdata.dateto != ""
        ) {
          this.filterTitle = " Stocktransfers Report From " +
                this.filterdata.datefrom +
                " To " +
                this.filterdata.dateto;
          return (
            element.transfer.sentOn >= date1 &&
            element.transfer.sentOn <= date2
          );
        }
        return this.filteredReport;
      });
    },

  },
  watch: {
    StockTransfersDetails(newValue){
      if(newValue){
        this.FetchfilteredData();
      }
    },
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
            this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  created() {
    this.FetchTransfers();
    this.FetchfilteredData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div v-if="filterTitle">
                <h4>
                  <center>{{ filterTitle }}</center>
                </h4>
              </div>
              <div class="col-4">
                <download-excel
                  class="btn btn-primary mt-4"
                  :data="filteredReport"
                  :fields="json_fields"
                  :worksheet="'STOCK_TRANSFER REPORT FOR' + currentdate"
                  type="csv"
                  :name="'Stocktransfer_report' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-file-excel"></i>
                </download-excel>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>From</label>
                  <input
                    @change="filterReport()"
                    type="date"
                    v-model="filterdata.datefrom"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>To</label>
                  <input
                    @change="filterReport()"
                    type="date"
                    v-model="filterdata.dateto"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="filteredReport?filteredReport:[]"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
              </b-table>
            </div>
            <Loader  v-if="!filteredReport"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
